import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
// import { register } from "../redux/Actions/UserActions";
import Header from "./../components/Header";
import Message from "./../components/LoadingError/Error";
import Loading from "./../components/LoadingError/Loading";
import { checkRef, register } from "../service";

const Register = ({ location, history }) => {
  window.scrollTo(0, 0);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [ref, setRef] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const dispatch = useDispatch();
  const redirect = location.search ? location.search.split("="[1]) : "/";

  const userRegister = useSelector((state) => state.userRegister);
  // const { error, loading, userInfo } = userRegister;

  // useEffect(() => {
  //   if (userInfo) {
  //     history.push(redirect);
  //   }
  // }, [userInfo, history, redirect]);

  // const submitHandler = (e) => {
  //   e.preventDefault();
  //   dispatch(register(name, email, password));
  // };

  const submitHandler = async (e) => {
    e.preventDefault();
    // if (!isChecked) {
    //   NotificationManager.warning("Read and accept Terms of Use and Privacy Policy")
    //   return
    // }
    setLoading(true)
    // setemail(values.email);
    // setref(values.ref);
    const resRef = await checkRef(ref);

    if (resRef.code === 200) {
      const res = await register(email);
      if (res?.code === 200) {
        history.push(`/verification-mail/${email}/${ref}`)
      } else {
        if (res?.message) {
          setError(res?.message)
          // NotificationManager.warning(res?.message)
        } else {
          setError('fail')
          // NotificationManager.warning("fail")
        }

      }
    } else {
      if (resRef?.message) {
        setError(resRef?.message)
        // NotificationManager.warning(resRef?.message)
      } else {
        setError('fail')
        // NotificationManager.warning("fail")
      }
    }
    setLoading(false)
    // dispatch(register(name, email, password));
    // dispatch(setLoading(false));
  }

  useEffect(() => {
    const url = window.location.href;
    const lastSlashIndex = url.lastIndexOf("/");
    const addressWithRefId = url.substring(lastSlashIndex + 1);
    const [address, queryString] = addressWithRefId.split("?");
    const params = new URLSearchParams(queryString);
    const refId = params.get("ref");
    setRef(refId);
    // document.getElementById("ref").value = refId
    return () => {
    };
  }, []);

  return (

    <div className="w-full flex justify-center items-center">
      <div className="w-[--page-width] p-16 flex flex-col justify-center items-center gap-4">
        {error && <Message variant="alert-info">{error}</Message>}
        {loading && <Loading />}
        
        <h4 className="text-center font-bold text-2xl">Đăng ký</h4>
        
        <form
          className="flex justify-center items-center flex-col w-72 gap-4"
          onSubmit={submitHandler}
        >
          {/* <input
            type="text"
            placeholder="Username"
            value={name}
            onChange={(e) => setName(e.target.value)}
          /> */}
          <input
            type="email"
            placeholder="Email"
            value={email}
            className="border rounded-xl text-sm p-2 w-full"
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            type="text"
            placeholder="Ref"
            value={ref}
            className="border rounded-xl text-sm p-2 w-full"
            onChange={(e) => setRef(e.target.value)}
          />
          {/* <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          /> */}

          <button type="submit" className=" bg-[--color-button-3] text-white hover:bg-[--color-button-2] hover:text-black px-4 py-2 rounded-full">Đăng kí</button>
          <Link
            to={redirect ? `/login?redirect=${redirect}` : "/login"}
            className="hover:text-[--color-button-3] text-sm"
          >
            Đã có tài khoản? <strong>đăng nhập</strong>
          </Link>

        </form>
      </div>
    </div>
  );
};

export default Register;
